<template>
    <section
        class="ps-page-hero"
        :class="{
            'ps-page-hero--compact': compact,
            'ps-page-hero--center': center,
        }"
    >
        <div class="ps-page-hero__mesh" aria-hidden="true" />
        <div class="ps-page-hero__grid" aria-hidden="true" />

        <div class="container ps-page-hero__inner">
            <nav v-if="breadcrumb.length" class="ps-page-hero__crumb" aria-label="Breadcrumb">
                <template v-for="(item, index) in breadcrumb" :key="`${item.label}-${index}`">
                    <Link
                        v-if="item.href"
                        :href="item.href"
                        class="ps-page-hero__crumb-link"
                    >
                        {{ item.label }}
                    </Link>
                    <span v-else class="ps-page-hero__crumb-current">{{ item.label }}</span>
                    <span
                        v-if="index < breadcrumb.length - 1"
                        class="ps-page-hero__crumb-sep"
                        aria-hidden="true"
                    >/</span>
                </template>
            </nav>

            <p v-if="eyebrow" class="ps-page-hero__eyebrow">{{ eyebrow }}</p>
            <h1 class="ps-page-hero__title">{{ title }}</h1>
            <p v-if="lead" class="ps-page-hero__lead">{{ lead }}</p>

            <div v-if="$slots.meta" class="ps-page-hero__meta">
                <slot name="meta" />
            </div>

            <div v-if="$slots.actions" class="ps-page-hero__actions">
                <slot name="actions" />
            </div>

            <div v-if="$slots.chips" class="ps-page-hero__chips">
                <slot name="chips" />
            </div>
        </div>

    </section>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
    components: { Link },
    props: {
        eyebrow: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            required: true,
        },
        lead: {
            type: String,
            default: '',
        },
        breadcrumb: {
            type: Array,
            default: () => [],
        },
        compact: {
            type: Boolean,
            default: false,
        },
        center: {
            type: Boolean,
            default: true,
        },
    },
}
</script>
